import { shouldBeTruthy, shouldBeBoolean } from '@/helpers/validation.js'

export default customField => {
  const valids = []
  valids.push(shouldBeTruthy(customField, 'fieldName', 'customField'))
  valids.push(shouldBeTruthy(customField, 'datatype', 'customField'))
  valids.push(shouldBeBoolean(customField, 'optional', 'customField'))
  return valids.reduce((a, b) => a && b)
}
